<app-bread-crumbs [breadcrumbs]="breadcrumbItems"></app-bread-crumbs>

<!-- Timeline Steps Section -->
<section class="professional-timeline-section">
  <div class="container">
    <app-timeline-steps
      [steps]="timelineSteps"
      [title]="'join_as_professional.join_as_professional_timeline_title'"
      [subtitle]="'join_as_professional.join_as_professional_timeline_subtitle'"
      [showDescription]="true">
    </app-timeline-steps>
  </div>
</section>
<!--
<div class="home5-about-section mb-5 mt-5">
  <div class="container">
    <div class="row g-lg-4 gy-5 align-items-center">
      <div class="col-12">
        <div class="container">
          <!-- Header
          <div class="row text-center mb-5">
            <div class="col-lg-8 mx-auto">
              <h2
                class="fw-bold text-success mb-4"
                data-translation-key="join_as_professional_join_as_professional_title"
              >
                {{ 'join_as_professional.join_as_professional_join_as_professional_title' | translate }}
              </h2>
              <p
                class="lead"
                data-translation-key="join_as_professional_join_as_professional_description"
              >
                {{ 'join_as_professional.join_as_professional_join_as_professional_description' | translate }}
              </p>
            </div>
          </div>

          <!-- Features Grid
          <div class="row g-4">
            <!-- Professional Networking
            <div class="col-md-6 col-lg-4">
              <div class="d-flex">
                <div class="flex-shrink-0 text-success me-3">
                  <i class="fas fa-users fs-4"></i>
                </div>
                <div>
                  <h5
                    class="text-success fw-semibold"
                    data-translation-key="join_as_professional_professional_networking"
                  >
                    {{ 'join_as_professional.join_as_professional_professional_networking' | translate }}
                  </h5>
                  <p
                    data-translation-key="join_as_professional_professional_networking_desc"
                  >
                    {{ 'join_as_professional.join_as_professional_professional_networking_desc' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Market Exposure
            <div class="col-md-6 col-lg-4">
              <div class="d-flex">
                <div class="flex-shrink-0 text-success me-3">
                  <i class="fas fa-chart-line fs-4"></i>
                </div>
                <div>
                  <h5
                    class="text-success fw-semibold"
                    data-translation-key="join_as_professional_market_exposure"
                  >
                    {{ 'join_as_professional.join_as_professional_market_exposure' | translate }}
                  </h5>
                  <p
                    data-translation-key="join_as_professional_market_exposure_desc"
                  >
                    {{ 'join_as_professional.join_as_professional_market_exposure_desc' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Industry Insights
            <div class="col-md-6 col-lg-4">
              <div class="d-flex">
                <div class="flex-shrink-0 text-success me-3">
                  <i class="fas fa-lightbulb fs-4"></i>
                </div>
                <div>
                  <h5
                    class="text-success fw-semibold"
                    data-translation-key="join_as_professional_industry_insights"
                  >
                    {{ 'join_as_professional.join_as_professional_industry_insights' | translate }}
                  </h5>
                  <p
                    data-translation-key="join_as_professional_industry_insights_desc"
                  >
                    {{ 'join_as_professional.join_as_professional_industry_insightsv_desc' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Event Listings
            <div class="col-md-6 col-lg-4">
              <div class="d-flex">
                <div class="flex-shrink-0 text-success me-3">
                  <i class="fas fa-calendar-alt fs-4"></i>
                </div>
                <div>
                  <h5
                    class="text-success fw-semibold"
                    data-translation-key="join_as_professional_event_listings"
                  >
                    {{ 'join_as_professional.join_as_professional_event_listings' | translate }}
                  </h5>
                  <p
                    data-translation-key="join_as_professional_event_listings_desc"
                  >
                    {{ 'join_as_professional.join_as_professional_event_listings_desc' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Custom Alerts
            <div class="col-md-6 col-lg-4">
              <div class="d-flex">
                <div class="flex-shrink-0 text-success me-3">
                  <i class="fas fa-bell fs-4"></i>
                </div>
                <div>
                  <h5
                    class="text-success fw-semibold"
                    data-translation-key="join_as_professional_custom_alerts"
                  >
                    {{ 'join_as_professional.join_as_professional_custom_alerts' | translate }}
                  </h5>
                  <p
                    data-translation-key="join_as_professional_custom_alerts_desc"
                  >
                    {{ 'join_as_professional.join_as_professional_custom_alerts_desc' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Secure Communication Platform
            <div class="col-md-6 col-lg-4">
              <div class="d-flex">
                <div class="flex-shrink-0 text-success me-3">
                  <i class="fas fa-lock fs-4"></i>
                </div>
                <div>
                  <h5
                    class="text-success fw-semibold"
                    data-translation-key="join_as_professional_secure_communication_platform"
                  >
                    {{ 'join_as_professional.join_as_professional_secure_communication_platform' | translate }}
                  </h5>
                  <p
                    data-translation-key="join_as_professional_secure_communication_platform_desc"
                  >
                    {{ 'join_as_professional.join_as_professional_secure_communication_platform_desc' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="about-section py-5">
      <div class="container">
        <div class="row row-gap-2">
          <!-- Right Column - Image
          <div class="col-lg-6 order-lg-1">
            <div class="about-content">
              <!-- Heading
              <div class="section-header mb-4" data-aos="fade-down">
                <h2
                  class="fw-bold display-5"
                  data-translation-key="join_as_professional_benefits_of_joining"
                >
                  {{ 'join_as_professional.join_as_professional_benefits_of_joining' | translate }}
                </h2>
                <div class="mb-4"></div>
              </div>

              <!-- Feature List
              <ul class="feature-list list-unstyled mb-4" data-aos="fade-up">
                <li class="d-flex align-items-start mb-3">
                  <i class="fas fa-check-circle text-success me-3 mt-1"></i>
                  <div>
                    <span
                      class="fw-bold"
                      data-translation-key="join_as_professional_globally"
                      >{{ 'join_as_professional.join_as_professional_globally' | translate }}</span
                    >
                    <p
                      class="mb-0"
                      data-translation-key="join_as_professional_globally_desc"
                    >
                      {{ 'join_as_professional.join_as_professional_globally_desc' | translate }}
                    </p>
                  </div>
                </li>
                <div class="mb-3"></div>

                <li class="d-flex align-items-start mb-3">
                  <i class="fas fa-check-circle text-success me-3 mt-1"></i>
                  <div>
                    <span
                      class="fw-bold"
                      data-translation-key="join_as_professional_tools"
                      >{{ 'join_as_professional.join_as_professional_tools' | translate }}</span
                    >
                    <p
                      class="mb-0"
                      data-translation-key="join_as_professional_tools_desc"
                    >
                      {{ 'join_as_professional.join_as_professional_tools_desc' | translate }}
                    </p>
                  </div>
                </li>
                <div class="mb-3"></div>

                <li class="d-flex align-items-start mb-3">
                  <i class="fas fa-check-circle text-success me-3 mt-1"></i>
                  <div>
                    <span
                      class="fw-bold"
                      data-translation-key="join_as_professional_industry"
                      >{{ 'join_as_professional.join_as_professional_industry' | translate }}</span
                    >
                    <p
                      class="mb-0"
                      data-translation-key="join_as_professional_industry_desc"
                    >
                      {{ 'join_as_professional.join_as_professional_industry_desc' | translate }}
                    </p>
                  </div>
                </li>
              </ul>

              <div class="mb-4"></div>

              <!-- CTA Button
              <a
                routerLink="/seller/auth/login"
                class="btn btn-success btn-md px-4 py-3 position-relative"
                data-translation-key="join_as_professional_login_as_professional"
              >
                {{ 'join_as_professional.join_as_professional_login_as_professional' | translate }}
                <i class="fas fa-chevron-right ms-2"></i>
              </a>
            </div>
          </div>
          <!-- Left Column - Content
          <div class="col-lg-6 order-lg-2 mb-4 mb-lg-0">
            <div class="about-img">
              <img
                [src]="
                  wordpressUrl +
                  'wp-content/uploads/2025/10/Doug-Prather-1.webp'
                "
                alt="Thoroughbred Horse"
                class="img-fluid rounded w-100 right-col-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div> -->

<div class="container">
  <div class="row mb-5">
    <div class="col-md-9 col-11 mx-auto">
      <app-contact-us-form></app-contact-us-form>
    </div>
  </div>
</div>
